export default (path, id, options) => {
  if (typeof path !== 'string') {
    throw new Error('insertId requires a string as first parameter')
  }

  path = path.replace(/:id/g, id)

  if (typeof options !== 'undefined') {
    Object.keys(options).forEach(key => {
      path = path.replace(new RegExp(`:${key}`, 'g'), options[key])
    })
  }

  return path
}
